import { render } from "./challanDocTwo.vue?vue&type=template&id=1e9c72b6&scoped=true"
import script from "./challanDocTwo.vue?vue&type=script&lang=js"
export * from "./challanDocTwo.vue?vue&type=script&lang=js"

import "./challanDocTwo.vue?vue&type=style&index=0&id=1e9c72b6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e9c72b6"]])

export default __exports__